import styles from 'styles/SectionIntroScreen.module.css'
import classNames from 'classnames'

import { sendSocketMessage } from 'config/socket/socketUtil'

import Reveal from 'reveal.js'
import { useEffect, useState, useRef } from 'react'

type PoseTimeScreenPropsType = {
  heading?: string;
  buttonText?: string;
  mascot?: string;
  classes?: any;
  slideTo?: number;
  isTeacher?: boolean;
  setSkipScreen?: any;
  slideIndex?: number;
  firebaseRef?: any;
  socketInstance: any;
}

function PoseTimeScreen({ heading, buttonText, mascot, classes, slideTo, isTeacher, setSkipScreen, slideIndex, socketInstance }: PoseTimeScreenPropsType) {
  useEffect(() => {
  //   socket.on('message', ({ className :lecture, id, message}: { className: string; id: string, message: any}) => {
  //     if( lecture === className && id === studentId && message.screen === "PoseTimeScreen") {
  //      if(message.operation === 'skip') {
  //       document.getElementById('posetimeSkipBtn')?.click();
  //      }
  //     }
  //   })

    const callbackFunction = (state: any) => {
      if(state.operation === 'skip') {
        document.getElementById('posetimeSkipBtn')?.click();
      }
    }
    socketInstance.onMessage('PoseTimeScreen', callbackFunction)
  },[])

  useEffect(()=>{
    if(slideIndex === 9)
      setSkipScreen && setSkipScreen(false);
  },[slideIndex])

  const onClickSkip = () => {
    setSkipScreen && setSkipScreen(true);
    slideTo ? Reveal.slide(slideTo) : Reveal.next();
  }

  const onClickButton = () => {
    // socket.emit('message', {className: className, id: studentId, message: { screen: 'PoseTimeScreen', operation: 'skip' }})
    document.getElementById('posetimeSkipBtn')?.click();
    sendSocketMessage({ state: { operation: 'skip' }, action: 'PoseTimeScreen'})
  }

  return (
    <div className={styles.container}>
      <div className={classNames(styles.heading, classes.heading)}>
        { heading }
      </div>
      <div className={styles.imagesContainer}>
        <img
          src={mascot}
          alt='mascot'
          className={classNames(styles.image, classes.img)}
        />
      </div>
      { (buttonText) &&
        <div className={classNames(styles.button, classes.button, {[styles.hidden]: !isTeacher})} onClick={onClickButton}>
        { buttonText }
        </div>
      }
      <button id='posetimeSkipBtn' onClick={onClickSkip} className={styles.hidden}/>
    </div>
  )
}

export default PoseTimeScreen
